import ProCheckResult from "../rest/procheck/model/ProCheckResult";

const sortProCheckTests = (tests: ProCheckResult[]): ProCheckResult[] => {
  return tests.sort((a, b) => {
    const now = new Date().getTime();

    const aToDate = new Date(a.tested_at).getTime();
    const bToDate = new Date(b.tested_at).getTime();
    return Math.abs(aToDate - now) - Math.abs(bToDate - now);
  });
};

export default sortProCheckTests;
